export default "__VITE_ASSET__BoucUdpV__"